export const commonEN = require("./commonEN.json");
export const pagesEN = require("./pagesEN.json");
export const messagesEN = require("./messagesEN.json");
